import React from 'react';

export default class ItemErrorHandler extends React.Component {
    constructor(props) {
        super(props);
        this.state = { errorOccurred: false };
    }

    static getDerivedStateFromError() {
        return { errorOccurred: true };
    }

    componentDidCatch(error) {
        console.error(error);
        if (this.props.onError) {
            this.props.onError(error);
        }
    }

    render() {
        if (this.state.errorOccurred) return null;
        return this.props.children;
    }
}
